<template>
    <div>
        <ul
            v-if="items.length && !isWindowSmall"
            class="tabs"
        >
            <li
                v-for="(item, index) in items"
                class="tabs__item"
                :class="{ 'tabs__item--inactive': !item.isActive }"
                :key="index">
                <router-link
                    :class="{ 'tabs__link--active': item.isActive }"
                    :to="item.to"
                    class="tabs__link"
                    replace
                >
                    <span
                        class="tabs__link-inner"
                        :class="{ 'tabs__link-inner--first': index === 0 }">{{ item.label }}</span>
                </router-link>
            </li>
        </ul>

        <dropdownComponent
            v-if="items.length && isWindowSmall"
            class="dropdown"
            v-on-click-outside="closeSegmentDropDown"
            :open="isDropdownOpen"
        >
            <div slot="trigger">
                <span @click="onClickDropdown">
                    <span class="dropdown__current-option">{{ activeItem.label }}</span>
                </span>
                <span
                    v-if="defaultItem && activeItem.label !== defaultItem.label"
                    class="icon-cancel dropdown-cancel"
                    @click="resetDropDown" />
                <span
                    v-else
                    class="icon-chevron-lg-down"
                    @click="onClickDropdown" />
            </div>

            <ul slot="option">
                <li
                    v-for="(item, index) in items"
                    class="dropdown__option-wrapper"
                    :class="{ 'dropdown__option-wrapper--active': item.label === item.isActive }"
                    :key="index"
                >
                    <router-link
                        class="dropdown__option"
                        :to="item.to"
                        @click.native="onClickDropdown"
                    >
                        {{item.label}}
                    </router-link>
                </li>
            </ul>
        </dropdownComponent>
    </div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside'
import dropdownComponent from 'core/components/DropdownComponent.vue'
import resizable from '../mixins/Resizable'

export default {
    computed: {
        activeItem () {
            return this.items.filter(item => item.isActive)[0]
        }
    },
    components: {
        dropdownComponent
    },
    data () {
        return {
            isDropdownOpen: false
        }
    },
    methods: {
        closeSegmentDropDown () {
            this.isDropdownOpen = false
        },
        onClickDropdown () {
            this.isDropdownOpen = !this.isDropdownOpen
        },
        resetDropDown () {
            this.$emit('reset-tabs-dropdown')
            this.closeSegmentDropDown()
        }
    },
    mixins: [
        onClickOutside,
        resizable
    ],
    props: {
        defaultItem: {
            required: false,
            type: Object
        },
        items: {
            default () {
                return []
            },
            required: false,
            type: Array
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.tabs {
    display: flex;
    flex-direction: row;
    padding-bottom: 8px;
    width: max-content;
    @media (--mq-large-min) {
        padding-bottom: 0;
    }
    & .tabs__item {
        & .tabs__link {
            background: white;
            border-bottom: 1px solid var(--c-primary);
            border-left: 1px solid var(--c-primary);
            border-top: 1px solid var(--c-primary);
            color: var(--c-primary);
            display: inline-block;
            font-size: 16px;
            padding: 5px 0;
            text-decoration: none;

            &.tabs__link--active {
                background: color(var(--c-primary) shade(20%));
                border-color: color(var(--c-primary) shade(20%));
                color: white;
                &:hover {
                    background: color(var(--c-primary) shade(20%));
                }
            }

            &:hover {
                background: #F0F0F0;
            }
        }
        & .tabs__link-inner {
            display: inline-block;
            padding: 0 16px;

            &.tabs__link-inner--first {
                border-left: none;
            }
        }

        &:first-child {
            & .tabs__link {
                border-top-left-radius: 2px;
                border-bottom-left-radius: 2px;
            }
        }
        &:last-child {
            & .tabs__link {
                border-top-right-radius: 2px;
                border-bottom-right-radius: 2px;
                border-right: 1px solid var(--c-primary);
                &.tabs__link--active {
                    background: color(var(--c-primary) shade(20%));
                    border-color: color(var(--c-primary) shade(20%));
                    color: white;
                    &:hover {
                        background: color(var(--c-primary) shade(20%));
                    }
                }
            }
        }
    }
}

.dropdown {
    color: #444649;
    font-size: 20px;

    & .dropdown-cancel {
        font-size: 16px;
        position: relative;
        top: 2px;
    }

    & .dropdown__option-wrapper {
        align-items: center;
        border-bottom: solid 1px #E7E9E9;
        cursor: pointer;
        display: flex;
        font-size: 16px;
        outline: none;
        white-space: nowrap;

        &:focus, &:hover, &.dropdown__option-wrapper--active {
            background: var(--c-dropdown-active-item-bg);
            border-left: 4px solid var(--c-interact-active);
            color: var(--c-accent-text);
        }
    }

    & .dropdown__option {
        height: 100%;
        padding: 10px 16px;
        width: 100%;
    }

    & .dropdown__current-option {
        text-decoration: underline;
    }

    & >>> .dropdown-container {
        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, .5);
        background-color: white;
        border-radius: 4px;
        box-shadow: 0 0 2px rgba(0, 0, 0, .5);
        overflow-y: auto;
        z-index: 40;
    }

    & >>> .icon-chevron-lg-down {
        font-size: 14px;
        padding-left: 4px;
    }
}

</style>
